import { Link, LinkProps } from "@mui/material";
import { Link as RouterLink } from "react-router";

interface LinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
    target?: "_blank" | "_self" | "_parent" | "_top"; // only real target values
}

export const LinkRouter = (props: LinkRouterProps) => {
    return <Link {...props} component={RouterLink} target={props.target} />;
};
